import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface DnaAlertMessage {
  type: 'success' | 'error' | 'info';
  text: string;
}

@Injectable({ providedIn: 'root' })
export class DnaAlertService {
  private _subject = new BehaviorSubject<DnaAlertMessage | null>(null);
  alert$ = this._subject.asObservable();

  success(text: string): void { this._subject.next({ type: 'success', text }); }
  error(text: string): void   { this._subject.next({ type: 'error',   text }); }
  info(text: string): void    { this._subject.next({ type: 'info',    text }); }
  clear(): void               { this._subject.next(null); }
}
